window.addEventListener('load', function() {
  let marketLanguages = document.querySelectorAll('.market__languages .language'),
      defaultSelectedLanguage = document.querySelector('.market__languages .language.language--selected'),
      savedLanguage = localStorage.getItem('selectedLanguage');

  if (savedLanguage) {
    let defaultSelectedLanguageStorage = document.querySelector(`.market__languages .language[data-lang="${savedLanguage}"]`);
    if(defaultSelectedLanguageStorage) defaultSelectedLanguage = defaultSelectedLanguageStorage;
    if(defaultSelectedLanguage){
      marketLanguages.forEach(lang =>{
        if(lang.dataset.lang == defaultSelectedLanguage.dataset.lang){
          lang.classList.add('language--selected')
        }else{
          lang.classList.remove('language--selected')
        }
      });
    }
  }

  if (Weglot && defaultSelectedLanguage) {
    Weglot.switchTo(defaultSelectedLanguage.dataset.lang);
  }

  if (Weglot && marketLanguages) {
    marketLanguages.forEach(language => {
      language.addEventListener('click', () => {
        marketLanguages.forEach(lang => lang.classList.remove('language--selected'));
        Weglot.switchTo(language.dataset.lang);
        localStorage.setItem('selectedLanguage', language.dataset.lang); // Save the selected language to localStorage
        language.classList.add('language--selected');
      });
    });
  }
});
